import React from "react";
import "./Main.css";
import Logo from "../components/Logo";
import Mobile from "../assets/Mobile.png";
import appstore from "../assets/appstore.png";
import { ReactComponent as Line } from "../assets/Vector.svg";

const Main = () => {
  const redirectToStore = () => {
    window.location.href = 'https://apps.apple.com/us/app/restrix/id6739803501'
  }
  return (
    <main className="main">
      <section className="main-content">
        <div className="main-items">
          <div className="main-left">
            <h1>
              <Logo />
            </h1>
            <p>
              Take control of your digital life with Restrix. Manage app and website usage, block distractions, and create a secure, focused environment—effortlessly and privately.
            </p>
            <button onClick={redirectToStore} >
              <img src={appstore} alt="DownloadBtn" />
            </button>
          </div>
        </div>
        <div className="main-items main-right">
          <img src={Mobile} alt="MobileImage" className="mobile-img" />
          <Line className="mobile-view-line" />
        </div>
        <h1 className="mobile-view-heading">
          <Logo />
        </h1>
      </section>
      <Line className="desktop-view-line" />
    </main>
  );
};

export default Main;
